import { BODY_FONT, splitLines, wrapText } from '../text.utils'
import type { TicketElement } from '../TicketElement'

export class AdditionalInfo implements TicketElement {
  lineHeight: number
  topMargin: number
  additionalInfo?: string

  constructor({ ticketInfo }: { ticketInfo?: string }) {
    this.lineHeight = 22
    this.topMargin = 20
    this.additionalInfo = ticketInfo
  }

  height(ctx: CanvasRenderingContext2D, width: number): number {
    if (!this.additionalInfo) return 0
    ctx.font = `14px ${BODY_FONT}`
    const lines = splitLines(ctx, this.additionalInfo, (2 / 3) * width).length
    return this.lineHeight * lines + this.topMargin
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): void {
    if (!this.additionalInfo) return
    top += this.topMargin
    ctx.font = `14px ${BODY_FONT}`
    ctx.textAlign = 'center'
    ctx.fillStyle = 'black'
    const lines = wrapText(ctx, this.additionalInfo, width / 2, top, (2 / 3) * width)
    top += this.lineHeight * lines
  }
}
